import "./index.scss";

const TeamMember = ({ img, memberName }) => {
  return (
    <div className="team-member">
      <img className="image" src={img} alt="team member" />
      <div className="member-name">{memberName}</div>
    </div>
  );
};
export default TeamMember;
